import React, { useState, useRef } from 'react';
import axios from 'axios';
import { IconButton, CircularProgress, Dialog, Tooltip } from '@material-ui/core';
import { Cancel, CloudUpload } from '@mui/icons-material';
import { borderColor } from './common';
import common from '~/common';
import { logError } from '~/common/utils';

const developIp = `${common.Ip.Actions}/v2`;
const getHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const upLoad = (files, onChange, setLoading) => {
  setLoading(true);
  const formData = new FormData();
  try {
    Array.from(files || []).forEach((o, i) => formData.append('files', o));
    const config = getHeaders();
    config.headers['Content-Type'] = 'multipart/form-data';
    axios.post(`${developIp}/upload/file/`, formData, config)
      .then(res => {
        if (res.data.status === '200') {
          onChange(res.data.data.upload_files);
          setLoading(false);
        }
      })
      .catch(error => {
        logError(error, 'upLoad');
        setLoading(false);
      });
  } catch {
    logError(error, 'upLoad');
    setLoading(false);
  }
};
const downloadUrl = ({ name = '', id = '' }) => {
  axios.get(`${common.Ip.Actions}/v2/download/file/${id}/`, { responseType: 'blob', ...getHeaders() })
    .then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    })
    .catch(error => logError(error, 'downloadUrl'));
};

const FileText = ({ disabled = false, value = {}, onDel = () => {} }) => {
  const [over, setOver] = useState(false);
  const [over2, setOver2] = useState(false);
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
      }}
    >
      <Tooltip title={`下載 ${value.original_file_name}`}>
        <div
          onMouseOver={() => setOver(true)}
          onMouseOut={() => setOver(false)}
          style={{
            flex: 1,
            width: 0,
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            textDecoration: over ? 'underline' : 'none',
            color: over ? 'black' : '#01958E',
          }}
          onClick={() => downloadUrl({ name: value.original_file_name, id: value.id })}
        >
          <a>
            {value.original_file_name}
          </a>
        </div>
      </Tooltip>
      {!disabled && (
        <Tooltip title={`刪除 ${value.original_file_name}`}>
          <Cancel
            onMouseOver={() => setOver2(true)}
            onMouseOut={() => setOver2(false)}
            onClick={onDel}
            style={{ color: over2 ? 'black' : 'gray', cursor: 'pointer' }}
          />
        </Tooltip>

      )}
    </div>
  );
};

const EAA_Upload = ({
  displayBorder = false,
  disabled = false,
  hint = '上傳檔案',
  marginRight = 50,
  onChange = () => {},
  value = [],
  multiple = true,
  accept = '.pdf,.xlsx,.docx,.gif,.jpg,.bmp,.png',
}) => {
  const [over, setOver] = useState(false);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();

  return (
    <div
      style={{
        flex: 1,
        minHeight: 46,
        borderRadius: 14,
        border: ((displayBorder || over) && !disabled) ? `1px solid ${over ? 'black' : borderColor}` : '',
        backgroundColor: disabled ? '#ededed' : 'white',
        marginRight,
        display: 'flex',
        alignItems: 'center',
      }}
      onMouseOver={() => setOver(true)}
      onMouseOut={() => setOver(false)}
      // onClick={onClick}
      disabled={disabled}
    >
      <Dialog
        PaperComponent={() => <CircularProgress />}
        open={loading}
      />
      <div style={{ flex: 1, marginLeft: 12, fontSize: 16, textAlign: 'start' }}>
        {value.length === 0 && <div style={{ color: '#b8b8b8' }}>{hint}</div>}
        {value.map((o, i) => <FileText key={i} value={o} onDel={() => { value.splice(i, 1); onChange([...value]); }} disabled={disabled} />)}
      </div>
      <input
        ref={inputRef}
        type='file'
        style={{ display: 'none' }}
        accept={accept}
        multiple={multiple}
        value=''
        onChange={e => upLoad(e.target.files, multiple ? (ary = []) => onChange([...(value || []), ...ary]) : (ary = []) => onChange(ary), setLoading) }
      />
      <Tooltip title={'上傳檔案'}>
        <span>
          <IconButton disabled={disabled} onClick={() => inputRef.current.click()}>
            <CloudUpload style={{ color: 'gray', fontSize: 20, cursor: 'pointer' }} />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
};

export default EAA_Upload;
